import api from "./api";
import { APIs } from "../constants/APIConstants";
import { CALL_DATA, GLOBAL_MEETING_DATA } from "../constants/PublicVariables";

export default class RecordingAPI {
    recordingAPIReq() {
        return {
            sessionId: GLOBAL_MEETING_DATA.sessionId,
            roomSid: CALL_DATA.roomSID,
        };
    }

    startRecording() {
        return api.post(APIs.START_RECORDING.replace("{SessionId}", GLOBAL_MEETING_DATA.sessionId), this.recordingAPIReq());
    }

    stopRecording() {
        return api.post(APIs.STOP_RECORDING.replace("{SessionId}", GLOBAL_MEETING_DATA.sessionId), this.recordingAPIReq());
    }

    handleRoomAlertAPI(msg) {
        return api.post(APIs.ALERT_MESSAGE, msg);
    }
}
